import type { RouteConfig } from "@/router/types";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

export const CALENDAR_PATH = "/calendrier";

const CalendarPage = lazyWithRetry(() => import("@/features/calendar/pages/CalendarPage"));

const calendarRoutes: RouteConfig[] = [
  {
    path: CALENDAR_PATH,
    element: <CalendarPage />,
    isProtected: true,
    useMainLayout: true,
  },
];

export default calendarRoutes;
